<p-dialog
  data-testid="spu-faq-dialog"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '45rem' }"
  [header]="
    (viewMode
      ? 'goods.spu.form.faq.dialog_view_title'
      : initialData
        ? 'goods.spu.form.faq.dialog_edit_title'
        : 'goods.spu.form.faq.dialog_add_title'
    ) | translate
  "
  (onHide)="onCancel()"
  (visibleChange)="visibleChange.emit($event)"
>
  <form
    data-testid="spu-faq-dialog-form"
    [formGroup]="faqForm"
    class="grid grid-cols-1 md:grid-cols-2 gap-4"
    [class.pointer-events-none]="viewMode"
  >
    <div class="flex flex-col gap-1">
      <label for="spu-faq-dialog-question-vi" class="faq-dialog-label">
        {{ 'goods.spu.form.faq.question_vi' | translate }}
        <span class="text-red-500">*</span>
      </label>
      <textarea
        pTextarea
        id="spu-faq-dialog-question-vi"
        data-testid="spu-faq-dialog-question-vi"
        formControlName="questionVi"
        [placeholder]="'goods.spu.form.faq.question_vi_placeholder' | translate"
        rows="3"
        [disabled]="viewMode"
        class="w-full"
      ></textarea>
      @if (faqForm.get('questionVi')?.invalid && faqForm.get('questionVi')?.touched) {
        <small class="block text-xs text-red-500">
          {{ 'goods.spu.form.faq.validation.required' | translate }}
        </small>
      }
    </div>

    <div class="flex flex-col gap-1">
      <label for="spu-faq-dialog-answer-vi" class="faq-dialog-label">
        {{ 'goods.spu.form.faq.answer_vi' | translate }}
        <span class="text-red-500">*</span>
      </label>
      <textarea
        pTextarea
        id="spu-faq-dialog-answer-vi"
        data-testid="spu-faq-dialog-answer-vi"
        formControlName="answerVi"
        [placeholder]="'goods.spu.form.faq.answer_vi_placeholder' | translate"
        rows="3"
        [disabled]="viewMode"
        class="w-full"
      ></textarea>
      @if (faqForm.get('answerVi')?.invalid && faqForm.get('answerVi')?.touched) {
        <small class="block text-xs text-red-500">
          {{ 'goods.spu.form.faq.validation.required' | translate }}
        </small>
      }
    </div>

    <div class="flex flex-col gap-1">
      <label for="spu-faq-dialog-question-en" class="faq-dialog-label">
        {{ 'goods.spu.form.faq.question_en' | translate }}
      </label>
      <textarea
        pTextarea
        id="spu-faq-dialog-question-en"
        data-testid="spu-faq-dialog-question-en"
        formControlName="questionEn"
        [placeholder]="'goods.spu.form.faq.question_en_placeholder' | translate"
        rows="3"
        [disabled]="viewMode"
        class="w-full"
      ></textarea>
    </div>

    <div class="flex flex-col gap-1">
      <label for="spu-faq-dialog-answer-en" class="faq-dialog-label">
        {{ 'goods.spu.form.faq.answer_en' | translate }}
      </label>
      <textarea
        pTextarea
        id="spu-faq-dialog-answer-en"
        data-testid="spu-faq-dialog-answer-en"
        formControlName="answerEn"
        [placeholder]="'goods.spu.form.faq.answer_en_placeholder' | translate"
        rows="3"
        [disabled]="viewMode"
        class="w-full"
      ></textarea>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      @if (!viewMode) {
        <app-button
          [testId]="'spu-faq-dialog-cancel-btn'"
          [label]="'common.actions.cancel' | translate"
          type="secondary"
          [outlined]="true"
          (emitOnClick)="onCancel()"
        ></app-button>
        <app-button
          [testId]="'spu-faq-dialog-confirm-btn'"
          [label]="'common.actions.confirm' | translate"
          type="info"
          [disabled]="faqForm.invalid"
          (emitOnClick)="onConfirm()"
        ></app-button>
      } @else {
        <app-button
          [testId]="'spu-faq-dialog-close-btn'"
          [label]="'common.actions.close' | translate"
          type="secondary"
          [outlined]="true"
          (emitOnClick)="onCancel()"
        ></app-button>
      }
    </div>
  </ng-template>
</p-dialog>
